<template>
  <section>
    <div class="container">

      <div class="hero is-bold">
        <div class="hero-body" style="padding-left: 0px; padding-top: 0px">
          <div class="container">
            <h1 class="title" style="color:#3e8ed0">Analytics</h1>
            <h5 class="subtitle">General statistics for your displayed content.</h5>
          </div>
        </div>
      </div>
          <div class="columns is-multiline is-mobile">
<div class="column is-2 is-offset-1">
      <b-field label="Chart Type:">
      <b-select v-model="chartType">
              <option value="ColumnChart">Column Chart</option>
              <option value="PieChart">Pie Chart</option>
            </b-select>
    </b-field>
        </div>

            <div class="column is-2 is-offset-0">
      <b-field label="Parameter:">
      <b-select v-model="param">
              <option value="durationSec">Duration (sec)</option>
              <option value="noTimes">Impressions</option>
            </b-select>
    </b-field>
        </div>

        <div class="column is-2 is-offset-0" >
    <b-field label="Device:">
      <b-select v-model="selectedDevice">
              <option value="all">All devices</option>
              <option v-for="(device, id) in devices" :key="id" :value="id">{{device.name}}</option>
            </b-select>
            </b-field>
            </div>
            <div class="column is-3 is-offset-0" >
            <b-field label="Date Range:">
        <b-datepicker
            placeholder="Click to select..."
            v-model="dates"
            range>
        </b-datepicker>
    </b-field>
            </div>
        </div>
        <div  class="column is-2 is-offset-0" v-if="noResults">{{noResMess}}</div>
        <div v-if="chartData.length && noResults===false">
          <GChart
        :type="chartType"
        :data="chartType==='ColumnChart' ? chartData.slice(0,9) : chartData"
        :options="chartOptions"
    />
    <div class="column is-3 is-offset-1" border-color="black" >
    <b-button @click="viewAllData" type="is-success">View all data</b-button>
    </div>
    </div>
    </div>
  </section>
</template>

<script>
import axios from 'axios'
import { GChart } from 'vue-google-charts'
import AnalyticsFull from '@/components/analytics/AnalyticsFull'

export default {
  name: 'Analytics',
  data: () => {
    return {
      results: [],
      errors: [],
      noResults: false,
      noResMess: 'No results.',
      dates: [],
      datesFormatted: [],
      chartType: 'ColumnChart',
      selectedDevice: 'all',
      param: 'durationSec',
      deviceName: '',
      chartData: [],
      chartOptions: {
        width: 1100,
        height: 400,
        fontName: 'Nunito',
        sliceVisibilityThreshold: 0.07,
        title: '',
        // title: 'Dongle Viber Test, 3/21/2022 - 3/27/2022',
        is3D: true,
        bar: { groupWidth: '90%' }
      },
      loadingComponent: null
    }
  },
  computed: {
    devices () {
      return this.$store.state.devices
    }
  },
  watch: {
    param () {
      if (this.param === 'noTimes') {
        this.results.sort((a, b) => parseFloat(b.times) - parseFloat(a.times))
        var chD = [['Item', 'Impressions']]
        this.results.forEach((value, index) => {
          chD.push([ value['ns_item_name'], value['times'] ])
        })
        this.chartData = chD
      } else {
        this.results.sort((a, b) => parseFloat(b.total_no_of_seconds) - parseFloat(a.total_no_of_seconds))
        var chDP = [['Item', 'Duration in seconds']]
        this.results.forEach((value, index) => {
          chDP.push([ value['ns_item_name'], value['total_no_of_seconds'] ])
        })
        this.chartData = chDP
      }
    },
    dates () {
      this.loadingComponent = this.$buefy.loading.open()

      var startD = this.dates[0].toLocaleDateString('en-GB')
      var endD = this.dates[1].toLocaleDateString('en-GB')

      var stArray = startD.split('/')
      var endArray = endD.split('/')
      if (stArray[0].length === 1) {
        stArray[0] = '0' + stArray[0]
      }
      if (stArray[1].length === 1) {
        stArray[1] = '0' + stArray[1]
      }
      startD = stArray[2] + stArray[0] + stArray[1]
      if (endArray[0].length === 1) {
        endArray[0] = '0' + endArray[0]
      }
      if (endArray[1].length === 1) {
        endArray[1] = '0' + endArray[1]
      }
      endD = endArray[2] + endArray[0] + endArray[1]
      this.datesFormatted = [startD, endD]
      this.globalLogger('DATES FORMATTED in dates', this.datesFormatted)
      var path = null
      if (this.selectedDevice === 'all') {
        if (!this.getNotMigrated().includes(this.$store.state.uid)) {
          path = `https://us-central1-neods-c3270.cloudfunctions.net/expressApi/resultsnew/${this.$store.state.workspaceId}?start=${this.datesFormatted[0]}&end=${this.datesFormatted[1]}`
        } else {
          path = `https://us-central1-neods-c3270.cloudfunctions.net/expressApi/results/${this.$store.state.uid}?start=${this.datesFormatted[0]}&end=${this.datesFormatted[1]}`
        }
        axios.get(path)
          .then(response => {
            // JSON responses are automatically parsed.
            this.results = response.data
            if (!this.results.length) this.noResults = true
            else this.noResults = false
            if (this.param === 'noTimes') {
              this.results.sort((a, b) => parseFloat(b.times) - parseFloat(a.times))
              var chD = [['Item', 'Impressions']]
              this.results.forEach((value, index) => {
                chD.push([ value['ns_item_name'], value['times'] ])
              })
              this.chartData = chD
            } else {
              this.results.sort((a, b) => parseFloat(b.total_no_of_seconds) - parseFloat(a.total_no_of_seconds))
              var chDP = [['Item', 'Duration in seconds']]
              this.results.forEach((value, index) => {
                chDP.push([ value['ns_item_name'], value['total_no_of_seconds'] ])
              })
              this.chartData = chDP
            }
            var stD = this.dates[0].toLocaleDateString('en-GB')
            var enD = this.dates[1].toLocaleDateString('en-GB')
            if (stD === enD) {
              this.chartOptions.title = 'All devices, ' + stD
            } else {
              this.chartOptions.title = 'All devices, ' + stD + ' - ' + enD
            }
            this.loadingComponent.close()
          })
          .catch(e => {
            this.errors.push(e)
          })
      } else {
        if (!this.getNotMigrated().includes(this.$store.state.uid)) {
          path = `https://us-central1-neods-c3270.cloudfunctions.net/expressApi/resultsnew/${this.$store.state.workspaceId}/${this.selectedDevice}/?start=${this.datesFormatted[0]}&end=${this.datesFormatted[1]}`
        } else {
          path = `https://us-central1-neods-c3270.cloudfunctions.net/expressApi/results/${this.$store.state.uid}/${this.selectedDevice}/?start=${this.datesFormatted[0]}&end=${this.datesFormatted[1]}`
        }
        axios.get(path)
          .then(response => {
            // JSON responses are automatically parsed.
            this.results = response.data
            if (!this.results.length) this.noResults = true
            else this.noResults = false
            if (this.param === 'noTimes') {
              this.results.sort((a, b) => parseFloat(b.times) - parseFloat(a.times))
              var chD = [['Item', 'Impressions']]
              this.results.forEach((value, index) => {
                chD.push([ value['ns_item_name'], value['times'] ])
              })
              this.chartData = chD
            } else {
              this.results.sort((a, b) => parseFloat(b.total_no_of_seconds) - parseFloat(a.total_no_of_seconds))
              var chDP = [['Item', 'Duration in seconds']]
              this.results.forEach((value, index) => {
                chDP.push([ value['ns_item_name'], value['total_no_of_seconds'] ])
              })
              this.chartData = chDP
            }
            var stD = this.dates[0].toLocaleDateString('en-GB')
            var enD = this.dates[1].toLocaleDateString('en-GB')

            this.deviceName = this.$store.getters.getDeviceName(this.selectedDevice)

            if (stD === enD) {
              this.chartOptions.title = this.deviceName + ', ' + stD
            } else {
              this.chartOptions.title = this.deviceName + ', ' + stD + ' - ' + enD
            }

            this.loadingComponent.close()
          })
          .catch(e => {
            this.errors.push(e)
          })
      }
    },
    selectedDevice () {
      this.loadingComponent = this.$buefy.loading.open()
      var path = null
      if (this.selectedDevice === 'all') {
        if (!this.getNotMigrated().includes(this.$store.state.uid)) {
          path = `https://us-central1-neods-c3270.cloudfunctions.net/expressApi/resultsnew/${this.$store.state.workspaceId}?start=${this.datesFormatted[0]}&end=${this.datesFormatted[1]}`
        } else {
          path = `https://us-central1-neods-c3270.cloudfunctions.net/expressApi/results/${this.$store.state.uid}?start=${this.datesFormatted[0]}&end=${this.datesFormatted[1]}`
        }
        axios.get(path)
          .then(response => {
            // JSON responses are automatically parsed.
            this.results = response.data
            if (!this.results.length) this.noResults = true
            else this.noResults = false
            if (this.param === 'noTimes') {
              this.results.sort((a, b) => parseFloat(b.times) - parseFloat(a.times))
              var chD = [['Item', 'Impressions']]
              this.results.forEach((value, index) => {
                chD.push([ value['ns_item_name'], value['times'] ])
              })
              this.chartData = chD
            } else {
              this.results.sort((a, b) => parseFloat(b.total_no_of_seconds) - parseFloat(a.total_no_of_seconds))
              var chDP = [['Item', 'Duration in seconds']]
              this.results.forEach((value, index) => {
                chDP.push([ value['ns_item_name'], value['total_no_of_seconds'] ])
              })
              this.chartData = chDP
            }
            var stD = this.dates[0].toLocaleDateString('en-GB')
            var enD = this.dates[1].toLocaleDateString('en-GB')

            if (stD === enD) {
              this.chartOptions.title = 'All devices, ' + stD
            } else {
              this.chartOptions.title = 'All devices, ' + stD + ' - ' + enD
            }

            this.loadingComponent.close()
          })
          .catch(e => {
            // this.errors.push(e)
            this.noResults = true
          })
      } else {
        if (!this.getNotMigrated().includes(this.$store.state.uid)) {
          path = `https://us-central1-neods-c3270.cloudfunctions.net/expressApi/resultsnew/${this.$store.state.workspaceId}/${this.selectedDevice}/?start=${this.datesFormatted[0]}&end=${this.datesFormatted[1]}`
        } else {
          path = `https://us-central1-neods-c3270.cloudfunctions.net/expressApi/results/${this.$store.state.uid}/${this.selectedDevice}/?start=${this.datesFormatted[0]}&end=${this.datesFormatted[1]}`
        }
        axios.get(path)
          .then(response => {
            // JSON responses are automatically parsed.
            this.results = response.data
            if (!this.results.length) this.noResults = true
            else this.noResults = false
            if (this.param === 'noTimes') {
              this.results.sort((a, b) => parseFloat(b.times) - parseFloat(a.times))
              var chD = [['Item', 'Impressions']]
              this.results.forEach((value, index) => {
                chD.push([ value['ns_item_name'], value['times'] ])
              })
              this.chartData = chD
            } else {
              this.results.sort((a, b) => parseFloat(b.total_no_of_seconds) - parseFloat(a.total_no_of_seconds))
              var chDP = [['Item', 'Duration in seconds']]
              this.results.forEach((value, index) => {
                chDP.push([ value['ns_item_name'], value['total_no_of_seconds'] ])
              })
              this.chartData = chDP
            }
            var stD = this.dates[0].toLocaleDateString('en-GB')
            var enD = this.dates[1].toLocaleDateString('en-GB')

            this.deviceName = this.$store.getters.getDeviceName(this.selectedDevice)

            if (stD === enD) {
              this.chartOptions.title = this.deviceName + ', ' + stD
            } else {
              this.chartOptions.title = this.deviceName + ', ' + stD + ' - ' + enD
            }

            this.loadingComponent.close()
          })
          .catch(e => {
            // this.errors.push(e)
            this.noResults = true
          })
      }
    }
  },
  components: {
    GChart
  },
  methods: {
    viewAllData () {
      var startD = this.dates[0].toLocaleDateString('en-GB')
      var endD = this.dates[1].toLocaleDateString('en-GB')

      var deviceName = ''
      if (this.selectedDevice === 'all') {
        deviceName = 'All devices'
      } else {
        deviceName = this.$store.getters.getDeviceName(this.selectedDevice)
      }

      this.results.sort((a, b) => parseFloat(b.total_no_of_seconds) - parseFloat(a.total_no_of_seconds))

      this.$buefy.modal.open({
        parent: this,
        component: AnalyticsFull,
        props: { fullData: this.results, stD: startD, endD: endD, devName: deviceName },
        hasModalCard: true,
        trapFocus: true
        // onCancel: this.cancelAdd
      })
    }
  },
  created: function () {
    var path = null
    var startD = new Date()
    var endD = new Date()
    startD.setDate(startD.getDate() - 7)
    endD.setDate(endD.getDate() - 1)
    this.dates = [startD, endD]
    startD = startD.toLocaleDateString('en-GB')
    endD = endD.toLocaleDateString('en-GB')
    this.chartOptions.title = 'All devices, ' + startD + ' - ' + endD
    var stArray = startD.split('/')
    var endArray = endD.split('/')
    if (stArray[0].length === 1) {
      stArray[0] = '0' + stArray[0]
    }
    if (stArray[1].length === 1) {
      stArray[1] = '0' + stArray[1]
    }
    startD = stArray[2] + stArray[0] + stArray[1]
    if (endArray[0].length === 1) {
      endArray[0] = '0' + endArray[0]
    }
    if (endArray[1].length === 1) {
      endArray[1] = '0' + endArray[1]
    }
    endD = endArray[2] + endArray[0] + endArray[1]
    this.datesFormatted = [startD, endD]

    if (!this.getNotMigrated().includes(this.$store.state.uid)) {
      path = `https://us-central1-neods-c3270.cloudfunctions.net/expressApi/resultsnew/${this.$store.state.workspaceId}/?start=${startD}&end=${endD}`
    } else {
      path = `https://us-central1-neods-c3270.cloudfunctions.net/expressApi/results/${this.$store.state.uid}/?start=${startD}&end=${endD}`
    }
    axios.get(path)
      .then(response => {
        // JSON responses are automatically parsed.
        this.results = response.data
        if (!this.results.length) this.noResults = true
        else this.noResults = false
        var chDP = [['Item', 'Duration in seconds']]
        this.results.forEach((value, index) => {
          chDP.push([ value['ns_item_name'], value['total_no_of_seconds'] ])
        })
        this.chartData = chDP
      })
      .catch(e => {
        this.errors.push(e)
      })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/analytics/Analytics.vue